import Business from '@constants/Business'
import { postLink, postImage } from '@components/blog/utils/postLinks'
import schemaDate from './helpers/schemaDate'
import blogSchemaGenre from './helpers/blogSchemaGenre'

export default function blogArtilceList (articles, title = '') {
    return {
        "@context": "http://schema.org",
        "@type": "SearchResultsPage",
        "mainEntity": [{
            "@type": "ItemList",
            "isAccessibleForFree": true,
            "name": title,
            "itemListOrder": "http://schema.org/ItemListOrderDescending",
            "itemListElement": articleItems(articles)
        }]
    }
}

function articleItems (articles) {
    return articles.map((article, idx) => {
        const { author = '', created, docType, title = '' } = article

        const url = Business.host + postLink(article)
        const date = schemaDate(created)
        const image = Business.host + postImage(article)

        return {
            "@type": "ListItem",
            "position": idx + 1,
            "item": {
                "@type": "Article",
                "isAccessibleForFree": true,
                "headline": title,
                "author": {
                    "@type": "Person",
                    "name": author,
                },
                "genre": blogSchemaGenre(docType),
                "publisher": {
                    "@type": "Organization",
                    "name": "dostawczaki.pl",
                    "logo": {
                        "@type": "ImageObject",
                        "url": Business.host + '/assets/icons/large-samochody-fb.jpeg'
                    }
                },
                "url": url,
                "mainEntityOfPage": {
                    "@type": "WebPage",
                    "@id": url,
                },
                "image": image,
                "datePublished": date,
                "dateCreated": date,
                "dateModified": date,
            },
        }
    })
}